
import uploading from './uploading'
import { mapGetters } from 'vuex'
import { doExportReportReport } from '@/api/enterprise'
export default {
  props: [],
  components: {
    
    uploading
  },
  data() {
    return {
      reportUrl: '',
      showPage: false,
      showLoading: false,
      estimatedTotalTime: 0
    }
  },
  mounted() { 
  },
  computed: {
    ...mapGetters(['project_id', 'vip']),
  },
  methods: {
    closeRightPage() {
      this.$store.commit('app/doCloseRight', true)
      this.$emit('closeRightPage')
    },
    upVip() {
      $('#hideVipBtn').click()
    },
    async doFakeUpload(time) { 
      this.$refs.uploadingRef.fakeUpload(time)
      this.$store.commit('app/SET_PROJECT_ID', this.project_id)
      const res = await doExportReportReport({project_id: this.project_id, format: 'pdf'})       
      if (res.code == 0) {
        this.showPage = true
        this.$refs.uploadingRef.completeAnimation()
        this.reportUrl = res.data.url
      } else {
        this.$refs.uploadingRef.fail()
        this.$toasted.error(`报告未能成功下载，请截图后联系客服,报告id：${this.project_id}`, {position: "top-center", duration: 2000})
      }
      this.$store.commit('app/SET_PROJECT_LOADING', false)      
    }
  }
}
